'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RadioButton = require('material-ui/RadioButton');

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMRadioButton = function WMRadioButton(_ref) {
	var label = _ref.label,
	    disabled = _ref.disabled,
	    value = _ref.value;
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_RadioButton2.default, {
			label: label,
			disabled: disabled,
			value: value
		})
	);
};

exports.default = WMRadioButton;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMRadioButton/index.js